import React from 'react'
import PropTypes from 'prop-types'
import { Header } from 'semantic-ui-react'

import './Header.css'

class HeaderComponent extends React.PureComponent {
  render() {
    const { title, center, right, alignTop, ...props } = this.props
    return (
      <div
        className={`header-container ${ alignTop ? 'align-top' : '' }`}
        {...props}
      >
        <div className='header-left'>
          <Header as='h4'>
            {title}
          </Header>
        </div>
        <div className='header-center'>
          {center || null}
        </div>
        <div className='header-right'>
          {right || null}
        </div>
      </div>
    )
  }
}

HeaderComponent.propTypes = {
  title: PropTypes.string,
  center: PropTypes.node,
  right: PropTypes.node,
  alignTop: PropTypes.bool
}

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/elements/Header.js